import styled from '@emotion/styled';

export const EventRow = styled.div<{ $tone: 'success' | 'info' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  color: ${({ $tone }) =>
    $tone === 'success'
      ? 'var(--color-feedback-success)'
      : 'var(--color-font-secondary)'};
  background: ${({ $tone }) =>
    $tone === 'success'
      ? 'var(--color-feedback-success-bg)'
      : 'var(--color-background-lightest)'};
`;

export const ToolWithCapture = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CaptureThumb = styled.a`
  display: block;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-border-medium-light);
  border-radius: 4px;
  background: var(--color-background-lightest);

  &:hover {
    border-color: var(--color-border-medium);
  }

  &:focus-visible {
    outline: 2px solid var(--color-border-active);
    outline-offset: 1px;
  }

  & > img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 240px;
    object-fit: contain;
  }
`;
